import { useCallback } from 'react'

import { useScreen } from '@/store/screen'

export const useHero = () => {
  const { isBiggerMobile, isSmallDesktop, isTablet } = useScreen()

  const getHeadingSize = useCallback(() => {
    if (isBiggerMobile) return 'h5'
    if (isSmallDesktop) return 'h3'
    if (isTablet) return 'h2'
    return 'h2'
  }, [isBiggerMobile, isSmallDesktop, isTablet])

  return {
    getHeadingSize,
  }
}
